import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installHistoryObserver } from './utils/history';
import { installParentNavigationBridge } from './utils/notifyParent';

// Make client-side navigations observable so URL-driven pages (editor, highlights)
// re-read their id when embedded in a persistent iframe (Reshet WordPress), and
// let the WP parent drive navigation via a postMessage NAVIGATE (origin-checked).
installHistoryObserver();
installParentNavigationBridge();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
